<template>
  <div>
    <div class="task container-dropzone">
      <!-- <label> {{ task.label }} </label> -->
      <div id="uploadFile" :class="['w3-right', {'loading': loading}, {'active': dragEnter}]">
        <vue-dropzone
          ref="myVueDropzone"
          id="dropzone"
          :options="dropzoneOptions"
          :showRemoveLink="true"
          @vdropzone-success="showSuccess"
          v-tooltip="{content: task.info, delay: { show: 400, hide: 100 }, placement: 'left'}"
        />
      </div>
      <div class="dz-preview dz-file-preview">
        <transition name="fade" mode="out-in">
          <div v-if="!loading" class="dz-details">
            <div class="dz-filename"><span data-dz-name></span></div>
            <div class="dz-size" data-dz-size></div>
          </div>
          <spinner-loading v-else class="taskFileLoading" :size="18" />
        </transition>
      </div>
      <transition-group name="fade" mode="out-in">
        <div v-if="dzError && dzError !== '' && dzErrorShow" class="dz-error-message label error_validate" key="error-msg">
          <span data-dz-errormessage="" v-html="dzError"></span>
          <i class="sherpa-icon icon-cerrar" @click="hideDzError"></i>
        </div>
        <div v-else-if="taskResp && taskResp !== ''" class="label error_validate oky_validate" key="ok-msg">
          <span> {{ taskResp }} </span>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import SpinnerLoading from 'vue-simple-spinner'
import language from '../../language'

export default {
  name: 'definition-task-file',
  components: {
    vueDropzone: vue2Dropzone,
    SpinnerLoading
  },
  props: [
    'task',
    'definition',
    'definitionContentId',
    'repeatableGroupCode',
    'object',
    'taskRefresh',
    'languageSelected',
    'language',
    'authorization',
    'type'
  ],
  data () {
    return {
      loading: false,
      taskError: false,
      taskResp: '',
      dropzoneOptions: this.getDropzoneOptions(),
      mimeTypes: this.getMimeTypes(),
      dzError: '',
      dzErrorShow: false,
      languageLoaded: true,
      dragEnter: false
    }
  },
  methods: {
    setLanguageLoaded () {
      this.languageLoaded = true
    },
    getCurrentLanguage () {
      var result = null
      if (this.languageSelected) {
        result = this.languageSelected.key
      }
      if (!result) {
        result = this.getLang('isoCode')
      }
      return result
    },
    getDropzoneIcon () {
      var result = ''
      var fileExtensions = this.task.validation.format.regExp.split(',')
      for (var i = 0; i < fileExtensions.length && result === ''; i++) {
        if (fileExtensions[i] === '.zip') {
          result = 'icon-zip'
        } else if (fileExtensions[i] === '.jpg' || fileExtensions[i] === '.png' || fileExtensions[i] === '.gif') {
          result = 'icon-imagen'
        }
      }
      return result
    },
    checkFileExtension (fileType) {
      var result = false
      var fileExtensions = this.task.validation.format.regExp.split(',')
      for (var i = 0; i < this.mimeTypes.length && !result; i++) {
        var mimeType = this.mimeTypes[i]
        for (var k = 0; k < fileExtensions.length && !result; k++) {
          if (mimeType.id === fileExtensions[k]) {
            for (var j = 0; j < mimeType.mimes.length && !result; j++) {
              if (mimeType.mimes[j] === fileType) {
                result = true
              }
            }
          }
        }
      }
      return result
    },
    showSuccess: function (file, response) {
      if (response.requestResult) {
        this.taskResp = response.requestResultSuccess
        if (response.requestObject) {
          this.$emit('refreshDefinition', response.requestObject[0])
        }
      } else {
        if (response.requestResultError.requestErrorMsg) {
          this.dzError = response.requestResultError.requestErrorMsg.replace(/(?:\r\n|\r|\n)/g, '<br />')
        } else {
          this.dzError = this.getLang('error500header')
        }
        this.dzErrorShow = true
      }
      this.loading = false
    },
    getDropzoneOptions () {
      var self = this

      var taskUrl = this.type.domainEndpoint
      if (this.type.taskDomainEndpoint) {
        taskUrl += this.type.taskDomainEndpoint
      }
      taskUrl += this.task.type.endpoint

      return {
        timeout: 30 * 60 * 1000,
        url: taskUrl,
        paramName: 'files',
        maxFilesize: this.task.validation.format.lengthMax / (1024 * 1024), // bytes / (1024 * 1024) --> MB
        // filesizeBase: 1024,
        acceptedFiles: this.task.validation.format.regExp,
        maxFiles: 1,
        uploadMultiple: false,
        clickable: true,
        createImageThumbnails: false,
        autoProcessQueue: true,
        headers: {
          'authorization': this.authorization
        },
        success: function (file, response) {
          this.removeAllFiles(true)
        },
        sending: function (file, xhr, formData) {
          formData.set('id', self.definitionContentId)
          formData.set('code', self.repeatableGroupCode)
          formData.set('lang', self.getCurrentLanguage())
        },
        params: {
          'id': this.definitionContentId,
          'code': this.repeatableGroupCode,
          'lang': this.getCurrentLanguage()
        },
        dictFallbackMessage: this.getLang('dictFallbackMessage'),
        dictFallbackText: this.getLang('dictFallbackText'),
        dictFileTooBig: this.getLang('dictFileTooBig'),
        dictInvalidFileType: this.getLang('dictInvalidFileType'),
        dictResponseError: this.getLang('dictResponseError'),
        dictCancelUpload: this.getLang('dictCancelUpload'),
        dictCancelUploadConfirmation: this.getLang('dictCancelUploadConfirmation'),
        dictRemoveFile: this.getLang('dictRemoveFile'),
        dictRemoveFileConfirmation: null,
        dictMaxFilesExceeded: this.getLang('dictMaxFilesExceeded'),
        dictDefaultMessage: '<p><i class="sherpa-icon ' + this.getDropzoneIcon() + '" style="position:absolute;top:16px;left:0;right:0;text-align:center;font-size:2.1em;color:#ffbf28;"></i><br><span style="font-style:italic;position:absolute;top:60px;left:0;font-size:12px;color:#ffbf28;text-align:center;font-weight:900;padding:0;width:100%;">' + this.task.label + '</span></p>',
        accept: function (file, done) {
          if (self.checkFileExtension(file.type)) {
            done()
          } else {
            self.dzError = self.getLang('errorRegExp')
            self.dzErrorShow = true
          }
        },
        init: function () {
          this.on('addedfile', function (file) {
            self.dzError = null
            self.dzErrorShow = false
            self.loading = true
            self.taskResp = null
          })
          this.on('drop', function (file) {
            self.dzError = null
            self.dzErrorShow = false
            self.loading = true
            self.taskResp = null
            if (this.files.length > 0) {
              this.removeAllFiles(true)
            }
          })
          this.on('error', function (file, message) {
            self.dzError = message
            self.dzErrorShow = true
            self.loading = false
            this.removeFile(file)
          })
          this.on('dragover', function (event) {
            self.dragEnter = true
          })
          this.on('dragleave', function (event) {
            self.dragEnter = false
          })
        }
      }
    },
    getMimeTypes () {
      return [
        {
          id: '.zip',
          mimes: [
            'application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'
          ]
        },
        {
          id: '.rar',
          mimes: [
            'application/x-rar-compressed', 'application/octet-stream'
          ]
        },
        {
          id: '.jpg',
          mimes: [
            'image/jpeg', 'image/jpg'
          ]
        },
        {
          id: '.png',
          mimes: [
            'image/png'
          ]
        },
        {
          id: '.gif',
          mimes: [
            'image/gif'
          ]
        },
        {
          id: '.xls',
          mimes: [
            'application/vnd.ms-excel'
          ]
        },
        {
          id: '.xlsx',
          mimes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ]
        }

      ]
    },
    getLang (key) {
      return language(this.language, key)
    },
    hideDzError () {
      this.dzErrorShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
#uploadFile {
  position: relative;
  width: 100%;
  height: 100px;
  background-color: #fffcf5;
  border-radius: 3px;
  border-left: 1px dashed #ffbf28;
  border-right: 1px dashed #ffbf28;
  border-bottom: 1px dashed #ffbf28;

  #dropzone {
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
#uploadFile:hover,
#uploadFile.active {
  border-left: 1px solid #ffbf28;
  border-right: 1px solid #ffbf28;
  border-bottom: 1px solid #ffbf28;
  opacity: 0.6;
}
.error_validate.oky_validate {
  color: green !important;
  padding-top: 5px;
  text-align: center;
  position: static;
}
</style>

<style lang="scss">
/* .dropzone .dz-preview .dz-error-message, */
.dropzone .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark,
.dropzone .dz-preview .dz-progress,
.dropzone .dz-preview .dz-image,
.dropzone .dz-preview .dz-size {
  display: none !important;
}

.dropzone .dz-preview .dz-details,
.dz-preview.dz-file-preview {
  position: relative;

  .dz-filename,
  .dz-size {
    font-stretch: normal;
    line-height: 1.1;
    letter-spacing: normal;
    position: absolute;
    top: 60px;
    font-style: italic;
    font-weight: 400;
    padding: 0;
    font-size: 0.9em;
    margin-bottom: 2px;
    color: green;
    width: auto;
  }

  .taskFileLoading {
    position: relative;
    left: 0;
    right: 0;
    top: 40px;
    bottom: 0;
  }

  .dz-filename {
    top: 80px;
    display: none;
  }
}

.image {
  .dropzone .dz-preview .dz-details,
  .dz-preview.dz-file-preview {
    .taskFileLoading {
      top: 38px !important;
    }
  }
}

.loading {
  .dz-message {
    display: none;
  }
}

.label.error_validate.dz-error-message {
  position: static;
  padding: 15px 35px 10px 15px;
  border-radius: 4px;
  border: 1px dotted #999;
  z-index: 100000;
  background-color: #fff;
  cursor: default;
  height: 150px;
  overflow-y: auto;
  width: 100%;

  .icon-cerrar {
    color: #ff7643;
    position: absolute;
    right: 22px;
    bottom: 127px;
    cursor: pointer;
    transition: all 0.2s ease-in;
  }
  .icon-cerrar:hover {
    color: #FFBD42;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/taskFile.vue